import { render, staticRenderFns } from "./UploaderPopup.vue?vue&type=template&id=18926cce&scoped=true&lang=pug"
import script from "./UploaderPopup.vue?vue&type=script&lang=ts"
export * from "./UploaderPopup.vue?vue&type=script&lang=ts"
import style0 from "./UploaderPopup.vue?vue&type=style&index=0&id=18926cce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18926cce",
  null
  
)

export default component.exports